import api from './client'
import type { Member, FamilyMember, DirectoryMember } from '../types'

export interface UpdateProfileRequest {
  first?: string
  last?: string
  address?: string
  address2?: string
  city?: string
  state?: string
  zip?: string
  phone?: string
  email?: string
  votingPreference?: 'paper' | 'electronic' | null
}

export async function getProfile(): Promise<Member> {
  const { data } = await api.get<Member>('/members/me')
  return data
}

export async function updateProfile(fields: UpdateProfileRequest): Promise<Member> {
  const { data } = await api.put<Member>('/members/me', fields)
  return data
}

export interface FamilyResponse {
  isFamily: boolean
  isHead: boolean
  headAUID: string | null
  members: FamilyMember[]
}

export async function getFamily(): Promise<FamilyResponse> {
  const { data } = await api.get<FamilyResponse>('/members/me/family')
  return data
}

export async function addFamilyMember(auid: string): Promise<FamilyResponse> {
  const { data } = await api.post<FamilyResponse>('/members/me/family', { auid })
  return data
}

export async function removeFamilyMember(auid: string): Promise<FamilyResponse> {
  const { data } = await api.delete<FamilyResponse>(`/members/me/family/${auid}`)
  return data
}

export interface DirectoryParams {
  search?: string
  state?: string
  letter?: string
  page?: number
  limit?: number
}

export interface DirectoryResponse {
  members: DirectoryMember[]
  total: number
  page: number
  limit: number
  totalPages: number
}

export async function getDirectory(params: DirectoryParams = {}): Promise<DirectoryResponse> {
  const { data } = await api.get<DirectoryResponse>('/members/directory', { params })
  return data
}
